import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.49299 4.4295C10.2778 4.15121 11.122 3.99996 12 3.99996C12.878 3.99996 13.7222 4.15121 14.507 4.4295L16.872 1.59155L18.4084 2.87192L16.325 5.37205C17.5801 6.25948 18.5512 7.52339 19.0732 8.99996H22V11H19.4836C19.4945 11.1652 19.5 11.3319 19.5 11.5V16.5C19.5 16.668 19.4945 16.8347 19.4836 17H22V19H19.0732C18.0436 21.9129 15.2655 24 12 24C8.73445 24 5.95636 21.9129 4.92676 19H2V17H4.5164C4.50552 16.8347 4.5 16.668 4.5 16.5V11.5C4.5 11.3319 4.50553 11.1652 4.5164 11H2V8.99996H4.92681C5.44878 7.52339 6.41991 6.25948 7.67503 5.37205L5.59159 2.87192L7.12804 1.59155L9.49299 4.4295ZM15 12V10H9V12H15ZM15 18V16H9V18H15Z"}}]};

const BugReportFilled = Vue.extend<IconProps>({
  name: 'BugReportFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bug-report-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BugReportFilled;
